import React from 'react';
import PropTypes from 'prop-types';
import {
  IconButton, makeStyles, Tooltip,
} from '@material-ui/core';
import {
  Mail as MailIcon,
} from 'react-feather';
import { withPermissionsChecker } from 'wrappers';

const useStyles = makeStyles(theme => ({
  icon: {
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}));

/**
 * Componente que muestra el boton descargar
 * @param {*} param0
 */
const SendExcelMailButton = ({
  onClick, requiredPermissions = [], checkAccess,
}) => {
  const classes = useStyles();
  return (
    <IconButton
      className={classes.icon}
      onClick={() => onClick()}
      disabled={!checkAccess(requiredPermissions)}
    >
      <Tooltip title="Enviar excel">
        <MailIcon className={classes.icon} fontSize="large" />
      </Tooltip>
    </IconButton>
  );
};

SendExcelMailButton.defaultProps = {
  requiredPermissions: [],
};

SendExcelMailButton.propTypes = {
  onClick: PropTypes.func,
  checkAccess: PropTypes.func,
  requiredPermissions: PropTypes.arrayOf(PropTypes.string),
};

export default withPermissionsChecker(SendExcelMailButton);
